<!--FastBI产品-->
<template>
  <div class="upgradeDialog">
    <el-dialog
      :before-close="restForm"
      :title="'试用延期'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="560px"
    >
      <el-form :model="extensionData" ref="form" :rules="formRules">
        <el-form-item v-if="type == 'list' || type == 'fdc'" :label-width="formLabelWidth" :label="firstFormName">
          <el-input v-model="extensionData['code']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="当前有效期至">
          <el-input v-model="extensionData['expire_time']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="调整有效期至" prop="new_expire_time">
          <!-- value-format="yyyy-MM-dd hh:mm:ss" -->
          <el-date-picker
            v-model="extensionData.new_expire_time"
            type="date"
            align="right"
            size="small"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button @click="extensionSubmit" type="primary" :disabled="!extensionData.new_expire_time">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { AFLocalAdminDelay,AFAppLocalAdminDelay } from '@/api/afLocal';
import { AFCloudAdminDelay } from '@/api/afCloud';
import { FDCLocalAdminDelay } from '@/api/afFdc';

export default {
  data() {
    return {
      visible: false,
      formLabelWidth: '110px',
      formRules: {
        new_expire_time: [
          {
            required: true,
            message: '时间不能为空',
            trigger: 'blur',
          },
        ],
      },
      extensionData: {
        code: '',
        expire_time: '',
        new_expire_time: '',
        id: '',
      },
      firstFormName: '授权码',
      type:"list"
    };
  },
  mounted() {},
  methods: {
    initData(data, _modules) {
      this.type = _modules
      const { expire_time, code, auth_code, id, domain,module_id ,curentId} = data;
      console.log(data);
      
      this.extensionData = {
        code: auth_code || code,
        expire_time,
        new_expire_time: '',
        id,
        module_id,
        curentId
      };
    },
    restForm(done) {
      this.cancel();
      done();
    },
    show() {
      this.visible = true;
    },
    cancel(formName, close) {
      this.extensionData = {
        code: '',
        expire_time: '',
        new_expire_time: '',
        id: '',
        module_id:'',
        curentId:''
      };
    },
    async extensionSubmit() {
      let { id, new_expire_time,module_id,curentId } = this.extensionData;
      const data = { expire_time: new_expire_time };
      try {
        let method = AFLocalAdminDelay
        if (this.type == 'app'){
          method = AFAppLocalAdminDelay
        }else if (this.type == 'cloud_app'){
          method = AFCloudAdminDelay
          data['module_id'] = module_id
          id = curentId
        }else if (this.type == 'fdc_module' || this.type == 'fdc'){
          method = FDCLocalAdminDelay
        }
        const res = await method(id,data);
        if (res) {
          Message({
            message: `有效期成功调整为${new_expire_time}`,
            type: 'success',
            duration: 3 * 1000,
          });
          this.visible = false;
          /* 更新表格数据 */
          if (this.type == 'fdc') {
            this.$parent.getAuthData();
          } else {
            this.$parent.refreshAFOrdersApps();
          }
        }
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/agileFlow/extensionDialog.vue